import type { NRecords } from '@app/types';

export const paymentStatusSelectOptions: Array<{
  label: string;
  value: NRecords.ModelRecordSearchFilter['PaymentStatus'];
}> = [
  { label: 'Оплачено', value: 'Paid' },
  { label: 'Не оплачено', value: 'Unpaid' },
  { label: 'Все состояния', value: 'All' },
];
